// extracted by mini-css-extract-plugin
module.exports = {"splitContent":"fiveFastFacts_splitContent__hwgEA","fivefactsCarousel":"fiveFastFacts_fivefactsCarousel__3dSsE"};